import React, { useEffect, useRef, useState } from "react";
import "./Style.css";
import Layout from "../../../Components/Layout/Layout";
import CompanyProfile from "../../../Components/AiLeads/CompanyProfile/Index";
import CompanyProfileTabs from "../../../Components/AiLeads/CompanyProfileTabs/Index";
import { useLocation, useParams } from "react-router-dom/dist";
import axios from "axios";
import Loader from "../../../Components/Loader/Loader";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  GetUserId,
} from "../../../Utils/Utils";
import PDFdatafile from "../PDFDATA/PDFdatafile";
import PDFTabs from "../PDFDATA/PDFTabs";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import html2pdf from "html2pdf.js";
import CombinedPDFComponent from "../PDFDATA/CombinedData";
import LeadsProspectModal from "../../../Components/RequestUpdateModals/LeadsProspectModal";
import { useReactToPrint } from "react-to-print";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import { ClearIcon } from "@mui/x-date-pickers";
import OrganizationDetailsPagePdf from "../../../Components/AiLeads/CompanyProfileTabs/OrganizationDetailsPagePdf";
const AILeads = () => {
  const [isSalesForceTrigger, setIsSalesForceTrigger] = React.useState(false);
  const [isDecisionMakerExcel, setIsDecisionMakerExcel] = React.useState(false);
  const [archiveRecord, setArchiveRecord] = useState(false);
  const [trackRecord, setTrackRecord] = useState(false);
  const [addToFavorite, setAddToFavorite] = useState(false);
  const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
  const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
  const [leadsRequestModal, setLeadsRequestModal] = useState(false);
  const [successModel, setSuccessModel] = useState("");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const [generatePdf, setGeneratePdf] = useState(false);
  const [shareRecord, setShareRecord] = useState(false);
  const [showSalesForce, setShowSalesForce] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [isLoadInfoData, setIsLoadInfoData] = useState(false);
  const { id, tab } = useParams();
  const newdata = id;
  const [value, setValue] = React.useState(Number(tab));
  const [overviewPdfModal, setOverviewPdfModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadSingleTab, setDownloadSingleTab] = React.useState(false);
  const [downloadMultipleTab, setDownloadMultipleTab] = React.useState(false);
  const [breStatus, setBreStatus] = useState();
  const [selectedOuterRows, setSelectedOuterRows] = React.useState([]);
  const [trackingData, setTrackingData] = useState([]);
  const [disableTracking, setDisableTracking] = useState(false);
  const [dataForInformation, setDataForInformation] = useState("");
  const handleCheckbox = (type) => {
    if (type === "one") {
      setDownloadSingleTab(true);
      setDownloadMultipleTab(false);
    } else if (type === "two") {
      setDownloadSingleTab(false);
      setDownloadMultipleTab(true);
    }
  };
  const handleClosePdfModal = () => {
    setOverviewPdfModal(false);
    setDownloadSingleTab("");
    setDownloadMultipleTab("");
  };
  const handleShowPdfModal = (item) => {
    setOverviewPdfModal(true);
    setAnchorEl(null);
  };
  const informationData = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_org_description?org_id=${newdata}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          setDataForInformation(e?.data?.data[0]);
          setBreStatus(e.data.bre); 
          localStorage.removeItem("cns");
          localStorage.removeItem("cip");
          localStorage.removeItem("cdp");
        }
      })
      .catch(() => {
        // setLoading(false);
      });
  };

  useEffect(() => {
    if (newdata && isLoadInfoData) {
      informationData();
      setValue(Number(tab));
    } else {
      setIsLoadInfoData(true);
    }
  }, [newdata, isLoadInfoData]);

  const ref = useRef(null);

  const contentRef = useRef(null);

  // const handleToPDF = () => {
  //   setGeneratePdf(true);

  //   setTimeout(() => {
  //     const content = contentRef.current;
  //     const options = {
  //       filename: 'OrganizationBioTable.pdf',
  //       margin: 1,
  //       image: { type: 'jpeg', quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: {
  //         margin: Margin.MEDIUM,
  //         format: 'letter',
  //         orientation: 'landscape',
  //       },
  //     };

  //     html2pdf()
  //       .set(options)
  //       .from(content)
  //       .save()
  //       .then(() => {
  //         setGeneratePdf(false);
  //         handleClosePdfModal();
  //       })
  //       .catch(() => {
  //         setGeneratePdf(false);
  //       });
  //   }, 2000);
  // };

  const handleToPDF = () => {
    if (!industryLogo) {
      console.error("Industry logo not available");
      return;
    }

    setLoading(true); // Start loading

    setTimeout(() => {
      const checkImageLoaded = () => {
        const imgElement = document.querySelector("img");
        if (
          !imgElement ||
          !imgElement.complete ||
          imgElement.naturalHeight === 0
        ) {
          setTimeout(checkImageLoaded, 500); // Wait until image is loaded
        } else {
          setLoading(false); // Stop loading before generating PDF
          generatePDF();
        }
      };

      checkImageLoaded();
    }, 10000); // Wait for 10 seconds before checking image loading
  };

  const generatePDF = () => {
    const content = contentRef.current;
    const options = {
      filename: "OrganizationBioTable.pdf",
      margin: 1,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true }, // Ensures CORS images load
      jsPDF: {
        format: "letter",
        orientation: "landscape",
      },
    };

    html2pdf()
      .set(options)
      .from(content)
      .save()
      .then(() => {
        setGeneratePdf(false);
        handleClosePdfModal();
      })
      .catch(() => {
        setGeneratePdf(false);
      });
  };

  const crieRef = useRef();

  const handleToPDFCrie = () => {
    const content = crieRef.current;
    const options = {
      filename: "OrganizationCrie.pdf",
      margin: 1,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        margin: Margin.MEDIUM,
        format: "letter",
        orientation: "landscape",
      },
    };
    html2pdf().set(options).from(content).save();
  };

  const handlePrint = useReactToPrint({
    content: () => crieRef.current,
    pageStyle: `
      @page {
        size: landscape;
      }
      body {
        -webkit-print-color-adjust: exact; /* Ensure colors print correctly */
      }
    `,
  });

  React.useEffect(() => {
    if (shareRecord === true) {
      const subject = encodeURIComponent(
        `${dataForInformation?.name ? dataForInformation?.name : "-"} profile`
      );
      const body =
        encodeURIComponent(`Please find the attached link.`) +
        "%0D%0A" +
        encodeURIComponent(`${window.location.href}`);
      const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${subject}&body=${body}`;
      setShareRecord(false);
      window.open(gmailLink, "_blank");
    }
  }, [shareRecord]);

  const [industryLogo, setIndustryLogo] = useState("");

  const componentRef = React.useRef();
  const [isDownloading, setIsDownloading] = React.useState(false);

  // const handleOrganizationPdf = () => {
  //   setIsDownloading(true);
  //   const content = componentRef.current;
  //   const options = {
  //     filename: 'OrganizationsTabs.pdf',
  //     margin: 10,
  //     image: { type: 'jpeg', quality: 0.98 },
  //     html2canvas: { scale: 3, logging: true, letterRendering: true },
  //     jsPDF: { format: 'a4', orientation: 'landscape' },
  //     pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
  //   };
  //   html2pdf().set(options).from(content).save()
  //     .then(() => {
  //       setIsDownloading(false);
  //       handleClosePdfModal();
  //     })
  //     .catch(() => setIsDownloading(false));
  // };

  const handleOrganizationPdf = () => {
    if (!industryLogo) {
      console.error("Industry logo not available");
      return;
    }

    setIsDownloading(true);

    const checkImageLoaded = () => {
      const imgElement = document.querySelector("img");
      if (
        !imgElement ||
        !imgElement.complete ||
        imgElement.naturalHeight === 0
      ) {
        setTimeout(checkImageLoaded, 500); // Wait until the image loads
      } else {
        generateOrganizationPDF();
      }
    };

    checkImageLoaded();
  };

  const generateOrganizationPDF = () => {
    const content = componentRef.current;
    const options = {
      filename: "OrganizationsTabs.pdf",
      margin: 10,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 3,
        logging: true,
        letterRendering: true,
        useCORS: true,
      },
      jsPDF: { format: "a4", orientation: "landscape" },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .set(options)
      .from(content)
      .save()
      .then(() => {
        setIsDownloading(false);
        handleClosePdfModal();
      })
      .catch(() => setIsDownloading(false));
  };

  const handleTrackingdata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        setTrackingData(data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    handleTrackingdata();
  }, []);

  useEffect(() => {
    if (trackingData.length > 0 && dataForInformation?.org_id) {
      const isMatching = trackingData.some(
        (trackingItem) =>
          Number(trackingItem.org_id) === Number(dataForInformation.org_id)
      );

      setDisableTracking(isMatching);
    } else {
      setDisableTracking(false);
    }
  }, [trackingData, dataForInformation]);

  return (
    <>
      {loading ? <Loader /> : null}
      <Layout>
        <div
        // style={{ pageBreakInside: "avoid" }} ref={crieRef}
        >
          <div className="child-section-of-everypage-CompanyProfileScreen">
            <CompanyProfile
              disableTracking={disableTracking}
              value={value}
              setShareRecord={setShareRecord}
              dataForInformation={dataForInformation}
              handleToPDF={handleToPDF}
              setIsDecisionMakerExcel={setIsDecisionMakerExcel}
              isSalesForceTrigger={isSalesForceTrigger}
              isDecisionMakerExcel={isDecisionMakerExcel}
              rowData={newdata}
              setIsSalesForceTrigger={setIsSalesForceTrigger}
              setArchiveRecord={setArchiveRecord}
              setTrackRecord={setTrackRecord}
              setAddToFavorite={setAddToFavorite}
              setRequestUpdateRecord={setRequestUpdateRecord}
              showSalesForce={showSalesForce}
              disableRequestUpdate={disableRequestUpdate}
              handleOrganizationPdf={handleOrganizationPdf}
              overviewPdfModal={overviewPdfModal}
              handleShowPdfModal={handleShowPdfModal}
              handleClosePdfModal={handleClosePdfModal}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              downloadSingleTab={downloadSingleTab}
              downloadMultipleTab={downloadMultipleTab}
              handleCheckbox={handleCheckbox}
            />
          </div>
          <div className="child-section-CompanyProfileTabs">
            <CompanyProfileTabs
              handleTrackingdata={handleTrackingdata}
              selectedOuterRows={selectedOuterRows}
              setSelectedOuterRows={setSelectedOuterRows}
              isDownloading={isDownloading}
              value={value}
              setValue={setValue}
              handleToPDF={handleToPDF}
              dataForInformation={dataForInformation}
              breStatus={breStatus}
              rowData={newdata}
              setIsDecisionMakerExcel={setIsDecisionMakerExcel}
              isDecisionMakerExcel={isDecisionMakerExcel}
              isSalesForceTrigger={isSalesForceTrigger}
              setIsSalesForceTrigger={setIsSalesForceTrigger}
              setArchiveRecord={setArchiveRecord}
              archiveRecord={archiveRecord}
              trackRecord={trackRecord}
              setTrackRecord={setTrackRecord}
              setAddToFavorite={setAddToFavorite}
              addToFavorite={addToFavorite}
              requestUpdateRecord={requestUpdateRecord}
              setRequestUpdateRecord={setRequestUpdateRecord}
              setDisableRequestUpdate={setDisableRequestUpdate}
              setLeadsRequestModal={setLeadsRequestModal}
              handleToPDFCrie={handleToPDFCrie}
              handlePrint={handlePrint}
              setShowSalesForce={setShowSalesForce}
              handleOrganizationPdf={handleOrganizationPdf}
              componentRef={componentRef}
              informationData={informationData}
              industryLogo={industryLogo}
              setIndustryLogo={setIndustryLogo}
            />
          </div>
        </div>

        {/* code for download to pdf  */}
        <div
          style={{
            pageBreakInside: "avoid",
            display: generatePdf ? "block" : "none",
          }}
          ref={contentRef}
        >
          <div className="child-section-of-everypage-CompanyProfileScreen">
            {downloadMultipleTab && (
              <OrganizationDetailsPagePdf
                dataForInformation={dataForInformation}
                value={value}
                setValue={setValue}
                informationData={informationData}
                handleToPDFCrie={handleToPDFCrie}
                rowData={newdata}
                setDisableRequestUpdate={setDisableRequestUpdate}
                requestUpdateRecord={requestUpdateRecord}
                setRequestUpdateRecord={setRequestUpdateRecord}
                setIsSalesForceTrigger={setIsSalesForceTrigger}
                setShowSalesForce={setShowSalesForce}
                isSalesForceTrigger={isSalesForceTrigger}
                industryLogo={industryLogo}
                setIndustryLogo={setIndustryLogo}
              />
            )}
          </div>
        </div>

        {/* 
        <div style={{ display: generatePdf ? 'block' : 'none' }}>
          <div id="content-id" ref={contentRef} style={{ fontSize: '5px' }}>
            <CombinedPDFComponent style={{ width: "100%" }} dataForInformation={dataForInformation} rowData={newdata} />
          </div>
        </div> */}

        <LeadsProspectModal
          requestUpdateRecord={leadsRequestModal}
          setRequestUpdateRecord={setLeadsRequestModal}
          profileData={dataForInformation}
          peopleId={newdata}
          setSuccessModel={setSuccessModel}
          successModel={successModel}
        />
      </Layout>

      <Modal
        open={successModel == true}
        onClose={() => setSuccessModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto", width: "30%" }}>
            <div className="de_pad_req-up">
              <p className="cross-people-req-model">
                <ClearIcon onClick={() => setSuccessModel(false)} />
              </p>
              <p className="de_head">
                Your Record Update request has been successfully submitted. The
                JOI team will review your request and notify you when the record
                has been updated.
              </p>
            </div>
          </Box>
        </div>
      </Modal>

      <Modal
        open={overviewPdfModal}
        onClose={handleClosePdfModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-joiTraining-videos"
      >
        <Box sx={style} style={{ overflowY: "auto" }}>
          <div className="box-section-relative">
            <div className="de_pad">
              <h3>Download PDF</h3>
              <div className="checkboxes-optns">
                <div className="inputs-plus-box-dataenrich">
                  <input
                    type="checkbox"
                    checked={downloadSingleTab}
                    onChange={() => handleCheckbox("one")}
                  />
                  <p>Download Current Tab</p>
                </div>
                <div className="inputs-plus-box-dataenrich">
                  <input
                    type="checkbox"
                    checked={downloadMultipleTab}
                    onChange={() => handleCheckbox("two")}
                  />
                  <p>Download All Tabs</p>
                </div>
                <div className="btns-companyprofile-cncl-sumbmit">
                  <button
                    onClick={handleClosePdfModal}
                    className="cancel-btn-companyprofile"
                  >
                    Cancel
                  </button>
                  <button
                    className="downloadpdf-btn-companyprofile"
                    onClick={() => {
                      if (downloadSingleTab) {
                        handleOrganizationPdf();
                      } else if (downloadMultipleTab) {
                        setGeneratePdf(true);
                        handleToPDF();
                      }
                    }}
                  >
                    Download Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};
export default AILeads;
